/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

export * from 'SourceRoute/CategoryPage/CategoryPage.config';

export const SORT_KEY = {
    availability: 'availability',
    sell_qty: 'sell_qty'
};

export const gridPerPageDefaultValues = ['12', '24', '36'].map((value) => ({ label: value, value }));
export const listPerPageDefaultValues = ['5', '10', '15', '20', '25'].map((value) => ({ label: value, value }));
export const defaultGridPerPage = 24;
export const defaultListPerPage = 15;
